import React from 'react';
import ObjectEditor from './ObjectEditor';
import Modal from '../components/Modal';
import LoadingSpinner from '../components/LoadingSpinner';
import ConfirmAlert from '../components/ConfirmAlert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { empty } from '../regex';
import { addObjectApi, editObjectApi, deleteObjectApi } from '../api/api';
import AlertAccent from '../components/AlertErrorBox';
import { useObjectsStore, useUserStore } from '../stores';
import TitleWithIcon from '../components/TitleWithIcon';
import ObjectCard from '../features/Objects/ObjectCard';
import VacationMode from '../features/Objects/VacationMode';

const Objects = () => {
  const { user } = useUserStore();
  const { objects, getObjects, loading, setLoading } = useObjectsStore();
  const [objectToEditOrAdd, setObjectToEditOrAdd] = React.useState({ user_id: user.id, address: '', apartment: '' });
  const [validationErrors, setValidationErrors] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [showModeModal, setModeShowModal] = React.useState(false);
  const [showDelModal, setShowDelModal] = React.useState(false);

  const addObject = async () => {
    setLoading(true);
    await addObjectApi(
      objectToEditOrAdd,
      function () {
        setLoading(false);
        setShowModal(false);
      },
      function (err) {
        toast.error(err.error, { hideProgressBar: true });
        setLoading(false);
      }
    );
  };

  const editObject = async () => {
    setLoading(true);
    await editObjectApi(
      objectToEditOrAdd,
      function () {
        setLoading(false);
        setShowModal(false);
      },
      function (err) {
        toast.error(err.error, { hideProgressBar: true });
        setLoading(false);
      }
    );
  };

  const deleteObject = async () => {
    setLoading(true);
    await deleteObjectApi(
      objectToEditOrAdd.id,
      function (data) {
        setLoading(false);
        setShowDelModal(false);
      },
      function (err) {
        toast.error(err.error, { hideProgressBar: true });
        setLoading(false);
      }
    );
  };

  const validateObject = (object) => {
    const errors = [];
    if (empty.test(object.address)) {
      errors.push({ error: 'Адрес пустой' });
    }
    if (!object.apartment) {
      errors.push({ error: 'Номер квартиры пустой' });
    }
    return errors;
  };

  const addObjectHandler = async () => {
    const errors = validateObject(objectToEditOrAdd);
    if (errors.length === 0) {
      await addObject();
      await getObjects();
    } else {
      setValidationErrors(errors);
    }
  };

  const editObjectHandler = async () => {
    const errors = validateObject(objectToEditOrAdd);
    if (errors.length === 0) {
      await editObject();
      await getObjects();
    } else {
      setValidationErrors(errors);
    }
  };

  const deleteObjectHandler = async () => {
    await deleteObject();
    await getObjects();
  };

  const add = async () => {
    setValidationErrors([]);
    setObjectToEditOrAdd({ user_id: user.id, address: '', apartment: '', time_zone: 'Europe/Moscow' });
    setShowModal(true);
  };

  const edit = async (object) => {
    setValidationErrors([]);
    setObjectToEditOrAdd(object);
    setShowModal(true);
  };

  const del = async (object) => {
    setObjectToEditOrAdd(object);
    setShowDelModal(true);
  };

  const editMode = async (object) => {
    setObjectToEditOrAdd(object);
    setModeShowModal(true);
  };

  return (
    <div className="sm:flex min-h-screen items-start justify-center bg-gradient-to-r p-2 sm:p-4 from-[#ededed] to-[#dcdcdc]">
      <div className="w-full sm:max-w-sm md:max-w-xl lg:max-w-2xl xl:max-w-4xl 2xl:max-w-5xl">
        {loading ? (
          <LoadingSpinner loading={true} />
        ) : (
          <>
            <TitleWithIcon title={'Объекты'} handler={add} />
            <ObjectCard objects={objects} handleEdit={edit} handleDelete={del} handleMode={editMode} />
          </>
        )}
      </div>

      <Modal showModal={showModal && !user.verified_at} setShowModal={setShowModal} title="Добавление/Редактирование объекта">
        <AlertAccent
          title="Невозможно добавить/редактировать объект!"
          text="Аккаунт не подтвержден. Для подтверждения аккаунта перейдите пожалуйста по ссылке, отправленной на Вашу почту"
          showAlert={true}></AlertAccent>
      </Modal>

      <Modal
        showModal={showModal && user.verified_at}
        setShowModal={setShowModal}
        saveCb={() => {
          if (objectToEditOrAdd.id) {
            editObjectHandler();
          } else {
            addObjectHandler();
          }
        }}
        title={objectToEditOrAdd.id ? 'Редактирование объекта' : 'Добавление объекта'}
        error={validationErrors}>
        <ObjectEditor setObject={setObjectToEditOrAdd} object={objectToEditOrAdd} />
      </Modal>

      <ConfirmAlert showAlert={showDelModal} setShowAlert={setShowDelModal} delCb={() => deleteObjectHandler()} title="Удаление объекта">
        <AlertAccent text="Вы действительно хотите удалить объект?" showAlert={true}>
          <p>{'Адрес: ' + objectToEditOrAdd.address + ', ' + objectToEditOrAdd.apartment}</p>
          <p>{'Все привязанные к данному объекту устройства также будут удалены!'}</p>
        </AlertAccent>
      </ConfirmAlert>
      <VacationMode selectedObject={objectToEditOrAdd} showModal={showModeModal} setShowModal={setModeShowModal} />
    </div>
  );
};

export default Objects;
